module.exports = __webpack_public_path__ + "img/js.39acac4a.png";